import { LoanAvailabilty } from '@cash-web/data-access-cash-app-pay-api-types'

import { useCheckout } from '.'

export const useLoanDisabled = (): boolean => {
  const { checkout } = useCheckout()

  return checkout.data?.loan_availability === LoanAvailabilty.DISABLED
}
